import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const alteracaoPerfilProfissionalRoutes: Routes = [
  {
    path: 'alteracao-perfil-profissional',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./profissional/alteracao-perfil-profissional.component').then(
            (m) => m.AlteracaoPerfilProfissionalComponent,
          ),
        data: {
          title: 'Alteração de Perfil Profissional',
          roles: [
            Role.ALTERAC_PERFIL_PROFISS_VISUALIZAR,
            Role.ALTERAC_PERFIL_PROFISS_CADASTRAR,
          ],
          breadcrumb: [{ label: 'Alteração de Perfil Profissional' }],
        },
      },
      {
        path: 'solicitar',
        loadComponent: () =>
          import('./profissional/solicitacao/alteracao-perfil-profissional-solicitacao.component').then(
            (m) => m.AlteracaoPerfilProfissionalSolicitacaoComponent,
          ),
        data: {
          title: 'Alteração de Perfil Profissional',
          roles: [Role.ALTERAC_PERFIL_PROFISS_CADASTRAR],
          breadcrumb: [
            { label: 'Alteração de Perfil Profissional', url: '/alteracao-perfil-profissional' },
            { label: 'Solicitar Alteração' },
          ],
        },
      },
      {
        path: 'acompanhamento/:id',
        loadComponent: () =>
          import('./profissional/solicitacao/alteracao-perfil-profissional-solicitacao.component').then(
            (m) => m.AlteracaoPerfilProfissionalSolicitacaoComponent,
          ),
        data: {
          title:
            'Acompanhamento da Solicitação de Alteração de Perfil Profissional',
          roles: [
            Role.ALTERAC_PERFIL_PROFISS_VISUALIZAR,
            Role.ALTERAC_PERFIL_PROFISS_CADASTRAR,
          ],
          breadcrumb: [
            { label: 'Alteração de Perfil Profissional', url: '/alteracao-perfil-profissional' },
            { label: 'Acompanhamento da Solicitação de Alteração de Perfil Profissional' },
          ],
        },
      },
      {
        path: 'analise/:id/aprovacao',
        loadComponent: () =>
          import(
            './coordenador/aprovacao/alteracao-perfil-profissional-coordenador-aprovacao.component'
          ).then((m) => m.AlteracaoPerfilProfissionalCoordenadorAprovacaoComponent),
        data: {
          title: 'Painel da Coordenação',
          roles: [
            Role.ALTERAC_PERFIL_PROFISS_COORDENADOR_CONSULTAR,
            Role.ALTERAC_PERFIL_PROFISS_COORDENADOR_ANALISAR,
          ],
          breadcrumb: [
            { label: 'Consultar Alterações de Perfil', url: '/alteracao-perfil-profissional/analise' },
            { label: 'Painel da Coordenação' },
          ],
        },
      },
      {
        path: 'analise/:id/indeferimento',
        loadComponent: () =>
          import(
            './coordenador/indeferimento/alteracao-perfil-profissional-coordenador-indeferimento.component'
          ).then((m) => m.AlteracaoPerfilProfissionalCoordenadorIndeferimentoComponent),
        data: {
          title: 'Painel da Coordenação',
          roles: [
            Role.ALTERAC_PERFIL_PROFISS_COORDENADOR_CONSULTAR,
            Role.ALTERAC_PERFIL_PROFISS_COORDENADOR_ANALISAR,
          ],
          breadcrumb: [
            { label: 'Consultar Alterações de Perfil', url: '/alteracao-perfil-profissional/analise' },
            { label: 'Painel da Coordenação' },
          ],
        },
      },
      {
        path: 'analise/:id/visualizar',
        loadComponent: () =>
          import(
            './coordenador/analise/alteracao-perfil-profissional-coordenador-analise.component'
          ).then((m) => m.AlteracaoPerfilProfissionalCoordenadorAnaliseComponent),
        data: {
          title: 'Painel da Coordenação',
          somenteLeitura: true,
          roles: [
            Role.ALTERAC_PERFIL_PROFISS_COORDENADOR_CONSULTAR,
            Role.ALTERAC_PERFIL_PROFISS_COORDENADOR_ANALISAR,
          ],
          breadcrumb: [
            { label: 'Consultar Alterações de Perfil', url: '/alteracao-perfil-profissional/analise' },
            { label: 'Painel da Coordenação' },
          ],
        },
      },
      {
        path: 'analise/:id/indeferimento/visualizar',
        loadComponent: () =>
          import(
            './coordenador/indeferimento/alteracao-perfil-profissional-coordenador-indeferimento.component'
          ).then((m) => m.AlteracaoPerfilProfissionalCoordenadorIndeferimentoComponent),
        data: {
          title: 'Painel da Coordenação',
          somenteLeitura: true,
          roles: [
            Role.ALTERAC_PERFIL_PROFISS_COORDENADOR_CONSULTAR,
            Role.ALTERAC_PERFIL_PROFISS_COORDENADOR_ANALISAR,
          ],
          breadcrumb: [
            { label: 'Consultar Alterações de Perfil', url: '/alteracao-perfil-profissional/analise' },
            { label: 'Painel da Coordenação' },
          ],
        },
      },
      {
        path: 'analise/:id',
          loadComponent: () =>
          import(
            './coordenador/analise/alteracao-perfil-profissional-coordenador-analise.component'
          ).then((m) => m.AlteracaoPerfilProfissionalCoordenadorAnaliseComponent),
        data: {
          title: 'Painel da Coordenação',
          roles: [
            Role.ALTERAC_PERFIL_PROFISS_COORDENADOR_CONSULTAR,
            Role.ALTERAC_PERFIL_PROFISS_COORDENADOR_ANALISAR,
          ],
          breadcrumb: [
            { label: 'Consultar Alterações de Perfil', url: '/alteracao-perfil-profissional/analise' },
            { label: 'Painel da Coordenação' },
          ],
        },
      },
      {
        path: 'analise',
        loadComponent: () =>
          import(
            './coordenador/alteracao-perfil-profissional-coordenador.component'
          ).then((m) => m.AlteracaoPerfilProfissionalCoordenadorComponent),
        data: {
          title: 'Consultar Solicitação de Alteração de Perfil',
          roles: [
            Role.ALTERAC_PERFIL_PROFISS_COORDENADOR_CONSULTAR,
            Role.ALTERAC_PERFIL_PROFISS_COORDENADOR_ANALISAR,
          ],
          breadcrumb: [
            { label: 'Consultar Alterações de Perfil' },
          ],
        },
      },
    ],
  },
];
